/**
 * Thin typed wrapper around localStorage.
 * All keys are namespaced with "aia_" to avoid collisions.
 * Silently swallows errors (e.g. private browsing, quota exceeded).
 */

const NS = "aia_"

export const storage = {
	get<T>(key: string): T | null {
		try {
			const raw = localStorage.getItem(NS + key)
			return raw != null ? (JSON.parse(raw) as T) : null
		} catch {
			return null
		}
	},
	set<T>(key: string, value: T): void {
		try {
			localStorage.setItem(NS + key, JSON.stringify(value))
		} catch {
			// quota exceeded or private mode — non-fatal
		}
	},
	remove(key: string): void {
		try {
			localStorage.removeItem(NS + key)
		} catch {
			// ignore
		}
	},
}

/** Typed storage keys used across the app. */
export const STORAGE_KEYS = {
	DARK_MODE: "dark_mode",
	THEME_SNAPSHOT: "theme_snapshot",
	PALETTE_ID: "palette_id",
} as const
